export class GlobalData {
  constructor(key: string, data: any) {
    this.key = key;
    this.data = data;
  }
  rowid: number | undefined;
  key: string | undefined;
  data: any | undefined;
}
